module.exports = __webpack_public_path__ + "img/bg-question.0ad07212.png";